"use client";

import { getCookie } from "cookies-next";
import { useEffect, useState } from "react";

const useCookie = (name: string = "location") => {
  const [cookie, setCookie] = useState<string>();

  const location = getCookie(name);
  useEffect(() => {
    if (location && typeof location === "string") {
      setCookie(location);
    }
  }, [location]);

  // useEffect(() => {
  //   fetch(`/api/get-cookie/?name=${name}`, {
  //     next: { revalidate: 60 },
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setCookie(data.value);
  //     });
  // }, [name]);

  return cookie;
};

export default useCookie;
